import React from 'react';
import { Box, BoxProps, Container } from '@chakra-ui/react';
import BrowserSupport from '#coreComponents/BrowserSupport';

import PublicTopbar from './components/PublicTopbar';
import PublicFooter from './components/PublicFooter';

export interface PublicLayoutProps {
  contentWrapperProps?: BoxProps;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({
  children,
  contentWrapperProps,
}) => (
  <>
    <PublicTopbar />
    <Container
      maxW="container.xl"
      display="flex"
      flexGrow={1}
      my={4}
      flexDir="column"
      {...contentWrapperProps}
    >
      <BrowserSupport />
      <Box>{children}</Box>
    </Container>
    <PublicFooter />
  </>
);

export default PublicLayout;
